import Logo from 'components/ui/Logo';
import LongPoweredBy from 'components/ui/LongPoweredBy';
import ShortPoweredBy from 'components/ui/ShortPoweredBy';
import MinifiedLogo from 'components/ui/MinifiedLogo';
import { AppContext, AppContextType } from 'context/AppContext';
import * as React from 'react';
import { Box } from '@mui/material';

export type SystemLogoProps = {
    drawerOpen: boolean;
};

const SystemLogo = ({ drawerOpen }: SystemLogoProps) => {
    const { ownUser } = React.useContext(AppContext) as AppContextType;
    const [configuredAvatar, setConfiguredAvatar] = React.useState<Record<string, string> | undefined>();
    const showPoweredBy = process.env.REACT_APP_SHORT_COMPANY_PREFIX !== 'FS';

    React.useEffect(() => {
        if (showPoweredBy) {
            setConfiguredAvatar({
                configuredAvatar: process.env.REACT_APP_INSTANCE_LONG_LOGO || '',
                configuredShortAvatar: process.env.REACT_APP_INSTANCE_SHORT_LOGO || '',
                alt: process.env.REACT_APP_SHORT_COMPANY_PREFIX || ''
            });
        }
        if (ownUser?.company?.partner) {
            setConfiguredAvatar({
                configuredAvatar: ownUser?.company?.partner.configuredAvatar,
                configuredShortAvatar: ownUser?.company?.partner.configuredShortAvatar,
                alt: ownUser?.company?.partner.name
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {!configuredAvatar ? (
                <>{drawerOpen ? <Logo /> : <MinifiedLogo />}</>
            ) : (
                <>
                    {drawerOpen ? (
                        <img
                            src={configuredAvatar?.configuredAvatar}
                            alt={configuredAvatar?.alt}
                            style={{
                                minHeight: '40px',
                                maxHeight: '60px'
                            }}
                        />
                    ) : (
                        <img
                            src={configuredAvatar?.configuredShortAvatar}
                            alt={configuredAvatar?.alt}
                            style={{
                                minHeight: '40px',
                                maxHeight: '60px'
                            }}
                        />
                    )}
                    <Box pt={2}>{drawerOpen ? <LongPoweredBy /> : <ShortPoweredBy />}</Box>
                </>
            )}
        </>
    );
};

export default SystemLogo;
